export default import.meta.ROLLDOWN_FILE_URL_aKzlLX3gDVkvwj4SvITcuQ